import { render, staticRenderFns } from "./FulfilmentSettings.vue?vue&type=template&id=1237bed8"
import script from "./FulfilmentSettings.vue?vue&type=script&lang=ts"
export * from "./FulfilmentSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports